import L from 'leaflet';
import { mergeClasses } from '@griffel/react';
import { MAP_DEFAULT_ZOOM } from '../map/MapConstants';

export default class AttentionPin extends L.Marker 
{
	constructor(latlng, options = {}) 
	{
		super(latlng, options);

		this._zoomLevel = MAP_DEFAULT_ZOOM;

		this.initVars(options);
		this.setIcon(this.createIcon(options));

		this.on('click', () =>
		{
			if (this.onClick) this.onClick();
		});
	}

	initVars(options = {}) 
	{
		this._markerClassName = mergeClasses('map-pin', 'common', 'attention');
	}

	createIcon(options = {}) 
	{
		return L.divIcon(
		{
			className: this._markerClassName,
			html: this.makeHTML(options)
		});
	}

	makeHTML(options = {}) 
	{
		const svg = `
		<svg class="pin attention" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.28 120">
			<path class="base" d="m87.28,43.64C87.28,18.97,66.81-.91,41.94.03,19.37.89.97,19.24.04,41.8c-.52,12.57,4.29,24.01,12.34,32.28,9.02,9.25,16.7,19.72,22.21,31.41l6.13,13.01c.95,2.01,3.81,2.01,4.76,0l4.89-10.37c5.77-12.23,13.48-23.52,23.29-32.82,8.39-7.95,13.62-19.2,13.62-31.67Z"/>
			<g class="icon">
				<path class="cls-1" d="m43.64,54.64h0c-2.72,0-4.98-2.1-5.18-4.82l-1.92-26.3c-.3-4.12,2.96-7.64,7.1-7.64h0c4.14,0,7.4,3.51,7.1,7.64l-1.92,26.3c-.2,2.72-2.46,4.82-5.18,4.82Z"/>
				<circle class="cls-1" cx="43.64" cy="65.75" r="6.22"/>
			</g>
		</svg>
		`;

		return `<div class="pin-inner">${svg}</div>`;
	}

	handleUpdateZoom()
	{
		// Implement zoom level related updates here
	}

	get zoomLevel()
	{
		return this._zoomLevel;
	}

	set zoomLevel(value)
	{
		this._zoomLevel = value;
		this.handleUpdateZoom();
	}
}
